export class CreatedRequestResponse {
    requestId: number;
    hasProposedSolution: boolean;
}
